import elementspaneloverview from "../../../../assets/images/docs/elements/overview.png";
import domview from "../../../../assets/images/docs/elements/domview.png";
import classeditor from "../../../../assets/images/docs/elements/classeditor.png";
import addclasses from "../../../../assets/images/docs/elements/classeditor-suggestions.png";
import a11ytab from "../../../../assets/images/docs/elements/a11ytab.png";
import navigator from "../../../../assets/images/docs/navigator.png";
import flexgrid from "../../../../assets/images/blogs/pp131/flexgrid.png";
import debugpanel2 from "../../../../assets/images/docs/elements/debugpanel.png";
import layertree from "../../../../assets/images/docs/layertree.png";
import stylepanel from "../../../../assets/images/docs/elements/style.png";
import containerquerystylepanel from "../../../../assets/images/docs/containerquerystylepanel.png";
import shiftclickcolor from "../../../../assets/images/docs/elements/shiftclickcolor.mp4";
import badges from "../../../../assets/images/docs/elements/badges.png";
import customproptooltip from "../../../../assets/images/docs/elements/customprop-tooltip.png";
import pseudostates from "../../../../assets/images/docs/elements/pseudostates.png";
import eventlisteners from "../../../../assets/images/docs/elements/eventlisteners.png";
import edithtml from "../../../../assets/videos/docs/elements/edit-html.mp4";
import editselector from "../../../../assets/videos/blogs/pp28/editselector.mp4";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  elementspaneloverview,
  domview,
  classeditor,
  addclasses,
  a11ytab,
  navigator,
  flexgrid,
  debugpanel2,
  layertree,
  stylepanel,
  containerquerystylepanel,
  shiftclickcolor,
  badges,
  customproptooltip,
  pseudostates,
  eventlisteners,
  edithtml,
  editselector,
  ShortCutDisplay,
  React
};